import { render, staticRenderFns } from "./SetGradeSubject.vue?vue&type=template&id=f2a025d2&scoped=true"
import script from "./SetGradeSubject.vue?vue&type=script&lang=js"
export * from "./SetGradeSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a025d2",
  null
  
)

export default component.exports